import React from 'react';
import { IconProps, IconWrap } from './IconWrap';

export function IconChecked({ color = '#3A4B68', width = 10, height = 7, ...props }: IconProps) {
    return (
        <IconWrap {...props} width={width} height={height} viewBox="0 0 10 7" iconClass="checked">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.59018 6.81438L0.26833 3.4724C0.147536 3.3516 0.147536 3.15028 0.26833 3.02948L0.711244 2.58657C0.832039 2.46577 1.03336 2.46577 1.15416 2.58657L3.65058 5.10313C3.73111 5.18365 3.87204 5.18365 3.95257 5.10313L8.84475 0.170674C8.96555 0.0498794 9.16687 0.0498794 9.28767 0.170674L9.73058 0.613588C9.85138 0.734383 9.85138 0.935707 9.73058 1.0565L4.0331 6.81438C3.9123 6.95531 3.71098 6.95531 3.59018 6.81438Z"
                fill={color}
            />
        </IconWrap>
    );
}
